import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=25d8ea20&scoped=true&"
import script from "./BillingPlans.vue?vue&type=script&lang=js&"
export * from "./BillingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8ea20",
  null
  
)

export default component.exports